


















import { Component, Vue } from 'vue-property-decorator';
import { oneClickAlarmServer, zyScreenServer } from '@/api/installServer';

@Component({
  components: {},
})
export default class AlarmEquipDialogList extends Vue {
  dialogVisible: any = false;
  private total: any = 0;
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private tableData: any = [];
  loading: any = false;

  showDialog(data: any) {
    this.tableData = [];
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.total = 0;
    this.getListData();
    this.dialogVisible = true;
  }
  getListData() {
    zyScreenServer
      .getAlarmDeviceList({
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      })
      .catch((error: any) => {
        this.$message.error('获取失败,请稍后重试!');
      });
  }
  private handleSizeChange(size: number) {
    this.queryDataForm.pageNo = 1;
    this.queryDataForm.pageSize = size;
    this.getListData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getListData();
  }

  handleClose(done: any) {
    done();
  }
}
